import Wrapper from "./Wrapper";
import Panel from "./Panel";
import { useAssistantContext } from './Provider';

const Assistant = Wrapper;
export default Assistant;

export {
    Assistant,
    useAssistantContext,
    Panel,
}
